__turbopack_context__.v({
  "contact-content": "Faq-module-scss-module__9JNDXW__contact-content",
  "contact-info": "Faq-module-scss-module__9JNDXW__contact-info",
  "header-container": "Faq-module-scss-module__9JNDXW__header-container",
  "info": "Faq-module-scss-module__9JNDXW__info",
  "team": "Faq-module-scss-module__9JNDXW__team",
});
